import React from "react";
import { useSelector } from "react-redux";
import AdDataModal from "./ad-data-modal";
import ErrorModal from "./error-modal";
import ProgressModal from "./progress-modal";
import LoadingModal from "./loading-modal";
import TemplateModal from "./template-modal";
import UserModal from "./user-modal";
import MessageModal from "./message-modal";

const modals = {
  AdDataModal,
  ErrorModal,
  ProgressModal,
  LoadingModal,
  TemplateModal,
  UserModal,
  MessageModal,
};

const ModalManager = () => {
  let renderModal;
  const currentModal = useSelector((state) => state.modal || null);

  if (currentModal) {
    const { modalType, modalProps } = currentModal;
    const ModalComponent = modals[modalType];
    renderModal = <ModalComponent {...modalProps} />;
  }

  return <>{renderModal}</>;
};

export default ModalManager;
